module.exports = __webpack_public_path__ + "img/Pages-icon.815abcfd.svg";